<template>
  <div id="app">
    <router-view name="header"></router-view>
    <vue-page-transition name="fade" class="main">
      <router-view></router-view>
    </vue-page-transition>
    <router-view name="footer" class="foot"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  metaInfo() {
    return {
      title: process.env.VUE_APP_NAME,
      htmlAttrs: {
        lang: 'ru'
      }
    };
  },
  created() {
    this.$store.dispatch('tryAutoLogin');
  }
};
</script>

<style lang="scss">
$ag-accent-color: $mainColor;
$ag-active: rgba($mainColor, 0.35);

@import '~@ag-grid-community/all-modules/dist/styles/ag-grid.scss';
@import '~@ag-grid-community/all-modules/dist/styles/ag-theme-balham/sass/ag-theme-balham.scss';

@import '~@mdi/font/css/materialdesignicons.min.css';

// Import Bulma's core
@import '~bulma/sass/utilities/_all';

// Base size
// $body-size: 15px;

$primary: $mainColor;
$primary-invert: findColorInvert($primary);

$colors: (
  'white': (
    $white,
    $black
  ),
  'black': (
    $black,
    $white
  ),
  'light': (
    $light,
    $light-invert
  ),
  'dark': (
    $dark,
    $dark-invert
  ),
  'primary': (
    $primary,
    $primary-invert
  ),
  'info': (
    $info,
    $info-invert
  ),
  'success': (
    $success,
    $success-invert
  ),
  'warning': (
    $warning,
    $warning-invert
  ),
  'danger': (
    $danger,
    $danger-invert
  )
);

//sizes
$size-6: 0.5rem !default;

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

$navbar-burger-color: $white;

// Notification

$notification-padding: 1rem 1.5rem;

// Import Bulma and Buefy styles
@import '~bulma';
@import '~buefy/src/scss/buefy';

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main {
  flex: 1 1;
}

.foot {
  font-size: 0.8rem;
}

.loader {
  min-height: 10rem;
}

.select select option:disabled {
  color: #999;
  cursor: not-allowed;
}

/* MODALS */

.modal-close {
  background: rgba(10, 10, 10, 0.2);
}

.modal-background {
  background: rgba(0, 0, 0, 0.5);
}

.modal.has-overflow {
  position: fixed !important;
  overflow: auto !important;
  .modal-background {
    position: fixed !important;
  }
  .modal-content {
    overflow: visible !important;
  }
  .modal-card {
    overflow: visible !important;
  }
  .modal-card-body {
    overflow: visible !important;
  }
}
</style>
